import React from 'react';
import { motion } from 'framer-motion';
import { FiBriefcase, FiArrowRight } from 'react-icons/fi';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero" id="home">
      {/* Animated background elements */}
      <div className="hero-bg-effects">
        <div className="hero-orb hero-orb-1"></div>
        <div className="hero-orb hero-orb-2"></div>
        <div className="hero-orb hero-orb-3"></div>
        <div className="hero-grid-overlay"></div>
      </div>

      <div className="hero-container">
        <div className="hero-content-wrapper">
          <div className="hero-text">
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="hero-greeting"
            >
              Hi, I'm
            </motion.p>

            <motion.h1
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.4 }}
              className="hero-name"
            >
              Gayatri Duse
            </motion.h1>

            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.6 }}
              className="hero-tagline"
            >
              Building meaningful <span className="gradient-text">digital experiences</span>
            </motion.h2>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.8 }}
              className="hero-bio"
            >
Full Stack Developer | SIH-2025 Winner (Software Edition) | Winner ABB Live Project Competition’25 | NASA Space Apps Challenge-Global Finalist'24
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 1.0 }}
              className="hero-actions"
            >
              <a href="#projects" className="btn btn-primary">
                <FiBriefcase />
                Browse Work
              </a>
              <a href="#contact" className="btn btn-secondary">
                Get in Touch
                <FiArrowRight />
              </a>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;